var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('navbar'),(_vm.user !== null && _vm.coupons.length > 0)?[_c('h1',[_vm._v(_vm._s(_vm.user.name))]),_c('b-card',[_c('b-table',{attrs:{"fields":_vm.table.fields,"items":_vm.coupons}})],1)]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }